import { getSettingHelpCenterAIChatbotEmergencyStop } from "../settings/getSettingHelpCenterAIChatbotEmergencyStop";
import { getSettingHelpCenterAIChatbotNativeMobile } from "../settings/getSettingHelpCenterAIChatbotNativeMobile";
import { getSettingHelpCenterRetailerAIChatbot } from "../settings/getSettingHelpCenterRetailerAIChatbot";

import { isMobileApp } from "./isMobileApp";

// Emergency stop is a global setting that can be used to disable the chatbot for all users.
// Native mobile is a setting that can be used to disable the chatbot for native mobile users.
export const retailerChatbotSettingEnabled = () => {
  const isEmergencyStopped = getSettingHelpCenterAIChatbotEmergencyStop();
  const isNativeMobileEnabled = getSettingHelpCenterAIChatbotNativeMobile();
  const isChatbotEnabled = getSettingHelpCenterRetailerAIChatbot();

  if (isEmergencyStopped) {
    return false;
  }
  if (isMobileApp()) {
    return isNativeMobileEnabled && isChatbotEnabled;
  }
  return isChatbotEnabled;
};
